/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://44dny6jngbc2hlpbnoljshvir4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7ivrrynrxfcyzehh4poe2lv4r4",
    "aws_cognito_identity_pool_id": "us-east-2:4aecb2da-d074-4a22-87f9-69ff30871784",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_4iQqWLPXY",
    "aws_user_pools_web_client_id": "7jfu04rfsg8uhp9saau6kvjtv6",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "wilmingtonsantaphotos155137-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
